function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from "react";
import PropTypes from "prop-types";
import useTheme from "../hooks/useTheme";
import useResponsiveProp, { responsivePropType } from "../hooks/useResponsiveProp";
import Container from "./Container";
import Icon from "./Icon";
import Text from "./Text";
import { jsx as ___EmotionJSX } from "@emotion/core";
var DEFAULT_ITEM_PROPS = {
  minor: false,
  current: false
};
Item.DEFAULT_PROPS = DEFAULT_ITEM_PROPS;

function Item(_props) {
  var props = _objectSpread(_objectSpread({}, DEFAULT_ITEM_PROPS), _props);

  var minor = props.minor,
      current = props.current,
      index = props.index,
      total = props.total,
      isPrevious = props.isPrevious,
      majorStepNumber = props.majorStepNumber;
  var theme = useTheme();
  var label = useResponsiveProp(props, "label");
  var isFirst = index === 0;
  var isLast = index === total - 1;
  return ___EmotionJSX("div", {
    css: theme.stepper.getCSS({
      targetElement: "item",
      stepsCount: total
    })
  }, ___EmotionJSX("div", {
    css: theme.stepper.getCSS({
      targetElement: "labelContainer"
    })
  }, ___EmotionJSX("div", {
    css: theme.stepper.getCSS({
      targetElement: "label"
    })
  }, label && ___EmotionJSX(Text, {
    textStyle: "body2",
    color: current ? "primary.blue.t100" : "black",
    align: "center"
  }, ___EmotionJSX("strong", null, label)))), ___EmotionJSX("div", {
    css: theme.stepper.getCSS({
      targetElement: "itemContent"
    })
  }, !isFirst && ___EmotionJSX("div", {
    css: theme.stepper.getCSS({
      targetElement: "progressLeft",
      isPrevious: isPrevious,
      isCurrent: current
    })
  }), !isLast && ___EmotionJSX("div", {
    css: theme.stepper.getCSS({
      targetElement: "progressRight",
      isPrevious: isPrevious
    })
  }), ___EmotionJSX("div", {
    css: theme.stepper.getCSS({
      targetElement: "circle",
      isMinor: minor,
      isCurrent: current,
      isPrevious: isPrevious
    })
  }, isPrevious && !minor && ___EmotionJSX(Icon, {
    name: "tick",
    color: "white"
  }), !isPrevious && !minor && ___EmotionJSX(Text, {
    textStyle: "subtitle2",
    color: isPrevious ? "white" : "black"
  }, ___EmotionJSX("strong", null, majorStepNumber)))));
}

Item.propTypes = _objectSpread(_objectSpread({}, responsivePropType("label", PropTypes.node)), {}, {
  minor: PropTypes.bool,
  current: PropTypes.bool,
  index: PropTypes.number,
  total: PropTypes.number,
  isPrevious: PropTypes.bool,
  majorStepNumber: PropTypes.number
});
var DEFAULT_PROPS = {
  completed: false
};
Stepper.DEFAULT_PROPS = DEFAULT_PROPS;
Stepper.ID = "Stepper";
Stepper.HEIGHT_MAP = {
  "default": 100
};

function Stepper(_props) {
  var props = _objectSpread(_objectSpread({}, DEFAULT_PROPS), _props);

  var completed = props.completed,
      children = props.children,
      testId = props.testId;
  var theme = useTheme();
  var steps = React.Children.toArray(children).filter( // Ignore all children that aren't Step.Item
  function (child) {
    return child.type === Item;
  });
  var currentStepIndex = steps.findIndex(function (step) {
    return step.props.current === true;
  });
  return ___EmotionJSX(Container, {
    bg: "grey.t07",
    testId: testId
  }, ___EmotionJSX(Container, {
    hasBreakpointWidth: true
  }, ___EmotionJSX("div", {
    css: theme.stepper.getCSS({
      targetElement: "container"
    })
  }, steps.reduce(function (acc, step, index) {
    var minor = step.props.minor === true;
    acc.items.push( /*#__PURE__*/React.cloneElement(step, {
      index: index,
      total: steps.length,
      isPrevious: completed || index < currentStepIndex,
      majorStepNumber: minor ? null : acc.majorStepNumber
    }));

    if (!minor) {
      acc.majorStepNumber += 1;
    }

    return acc;
  }, {
    items: [],
    majorStepNumber: 1
  }).items)));
}

Stepper.Item = Item;
export default Stepper;